module.exports = __webpack_public_path__ + "static/media/43-6.7fdfeb5b.mp3";